import { request } from '@/shared/api';
export function fetchHomeBriefing() {
    return request('/api/v1/home');
}
